import {
  GET_PERSONALIZATION_CONTENT_SUCCESS,
  PERSONALIZATION_CONTENT_OBJECT_REQUESTING,
  RESET_PERSONALIZATION_CONTENT_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_PERSONALIZATION_CONTENT_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case PERSONALIZATION_CONTENT_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_PERSONALIZATION_CONTENT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getPersonalizationBlockByCode = (personalizationBlock, code) => {
  if (!personalizationBlock.data) {
    return null;
  }
  const personalizationBlockIds = Object.keys(personalizationBlock.data);
  const personalizationBlockByCodeId = personalizationBlockIds.find(
    (id) => personalizationBlock.data[id].code === code
  );
  if (personalizationBlockByCodeId) {
    return personalizationBlock.data[personalizationBlockByCodeId];
  }
  return null;
};
